export default "__VITE_ASSET__b81a4ac6__"